<template>
  <form class="p-4" @submit.prevent="createIssue">
    <div class="space-y-8 divide-y divide-gray-200">
      <div>
        <div>
          <h3 class="text-lg leading-6 font-medium text-gray-900"> {{ $t('issues.new_issue_label') }} </h3>
          <!-- <p class="mt-1 text-sm text-gray-500"> This information will be used to create a new issue. </p> -->
        </div>

        <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
          <div class="sm:col-span-6 w-1/2">
            <label for="description" class="block text-sm font-medium text-gray-700"> {{ $t('issues.relatable_label') }} </label>
            <div class="mt-1">
              <input v-model="relatableName" disabled type="text" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md">
            </div>
          </div>

          <div class="sm:col-span-6 w-1/2">
            <label for="description" class="block text-sm font-medium text-gray-700"> {{ $t('issues.description_label') }} </label>
            <div class="mt-1">
              <textarea v-model="newIssue.description" id="description" name="description" rows="3" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md" required></textarea>
            </div>
          </div>

          <div class="sm:col-span-6 w-1/2">
            <label for="department" class="block text-sm font-medium text-gray-700"> {{ $t('issues.department_label') }} </label>
            <select v-model="selectedDepartment" id="department" name="department" autocomplete="department-name" class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" required>
              <option v-for="option in departments" v-bind:value="option" v-bind:key="option">
                {{ titleize(option) }}
              </option>
            </select>
          </div>

          <div class="sm:col-span-6 w-1/2">
            <label for="topic" class="block text-sm font-medium text-gray-700"> {{ $t('issues.topic_label') }} </label>
            <select v-model="newIssue.topic" id="topic" name="topic" autocomplete="topic-name" class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" required>
              <option v-for="option in topicsForDepartment" v-bind:value="option" v-bind:key="option">
                {{ titleize(option) }}
              </option>
            </select>
          </div>

          <div class="sm:col-span-6 w-1/2">
            <label for="priority" class="block text-sm font-medium text-gray-700"> {{ $t('issues.priority_label') }} </label>
            <select v-model="newIssue.priority" id="priority" name="priority" autocomplete="priority-name" class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" required>
              <option value="" label=" "></option>
              <option value="low"> {{ $t('issues.low_option') }} </option>
              <option value="moderate"> {{ $t('issues.moderate_option') }} </option>
              <option value="urgent"> {{ $t('issues.urgent_option') }} </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="pt-5 flex justify-center">
      <button type="submit" class="m-2 btn btn-secondary" :disabled="newIssue.submitted"> {{ $t('issues.create_issue_label') }} </button>
    </div>
  </form>
</template>

<script>
  import axios from 'axios'
  import settingsMixin from "../../mixins/settingsMixin.vue";

  export default {
    name: '',
    mixins: [settingsMixin],
    data () {
      return {
        newIssue: {
          relatable_type: null,
          relatable_id: null,
          topic: null,
          description: null,
          created_by_id: null,
          submitted: false,
        },
        relatableName: null,
        departments: [],
        topics: [],
        selectedDepartment: null,
      }
    },
    created () {
      this.relatableName = this.data.relatable_name
      
      this.newIssue.created_by_id = this.data.created_by_id
      this.newIssue.relatable_type = this.data.relatable_type
      this.newIssue.relatable_id = this.data.relatable_id
      this.topics = window.gon['issue_config']['topics']
      this.departments = window.gon['issue_config']['departments']
      console.log(this.topics)

    },
    computed: {
      topicsForDepartment() {
        console.log(this.topics)
        return  this.selectedDepartment && this.topics.filter(topic => topic.startsWith(this.selectedDepartment))        
      }
    },
    methods: {
      createIssue () {
        if (!this.newIssue.submitted){
          this.newIssue.submitted = true
          axios.post(`/issues`, {
            issue: this.newIssue,
          }, {
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            }
          })
          .then(response => {
            console.log("The data", response)
            
            this.$emit("new-issue", {
              issue: this.newIssue,
            })

            return response
          }, error => {
            window.Rollbar.error('error creating issue', { error: error })
            console.log('error when creating issue: ', error)
          })
        }
      }
    },
    props: {
      data: {
        type: Object,
        required: false,
      },
    },
  }
</script>

<style lang="scss">
</style>
